import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles/tokens.css';
import './styles/base.css';

const root = document.querySelector('#root');
if (root === null) {
  throw new Error('index.html is missing the #root mount point');
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// The service worker (public/sw.mjs; .mjs so the lint gate reads it as plain
// JavaScript) caches the shell and hashed assets so the app installs and
// opens offline; it never touches /api/. Production only: in development
// Vite serves unhashed modules that must not be cached.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.mjs').catch((error: unknown) => {
      console.error('Service worker registration failed', error);
    });
  });
}
